import DelayedRow from './DelayedWorkRow';

export default DelayedRow;
